export const WIZARD_NAME = 'SMS berichtenservice';
